import React from 'react';
import component, {classnames} from './../component';
import Flag from './../Flag';
import _ from 'lodash';
import {Table, Tr, Th, Td} from './../Table';
import {Tabs, Tab} from '../Tabs';
import Link from './../Link';
import {dateTimeYear} from '../DateFormats';

import {SlicedHamburger} from '../icons';

import {getRandomInt, randomString} from './../randomizer.js';

import TournamentDetails from './TournamentDetails';

import {summGameResults} from './../GamesItem.js';

const GroupMember = component('GroupMember', function(props){
  return (
    <Tr>
      <Td>
        <Link name="teamDetails" params={{id: props.groupMember.id}} className="TournamentGroupStage-GroupsGroupMembersMemberName">

            {props.groupMember.country && <Flag country={props.groupMember.country}/>}
            {props.groupMember.title}
        </Link>
      </Td>
      <Td>
        <span className="TournamentGroupStage-GroupsGroupMembersMemberPoints">{props.groupMember.score}</span>
      </Td>
    </Tr>
  );
});

const showGroupDetails = (popup, games)=> {
  const teams = _.reduce(games, (result, game) => {
    const teamA = game && game.team_a && game.team_a.id || null;
    const teamB = game && game.team_b && game.team_b.id || null;
    if (teamA !== null && !result.hasOwnProperty(teamA)) result[teamA] = game.team_a;
    if (teamB !== null && !result.hasOwnProperty(teamB)) result[teamB] = game.team_b;
    return result;
  }, {});

  popup.set({
    autoWidth: true,
    action: 'Готово',
    autoClose: true,
    message: React.renderToString(
      <div className="GroupDetails">
        <h2>Матчи группы</h2>
        <table>
          <tbody>
            <tr key={0}>
              <th key={0} className="GroupDetails-Hint">Игры</th>
              {_.map(teams, (teamTop, index)=>
                <th className="GroupDetails-Team" key={index}>
                  <Link name="teamDetails" params={{id: teamTop.id}}>{teamTop.title}</Link>
                </th>
              )}
            </tr>
            {_.map(teams, (teamLeft, index) =>
              <tr key={index + 1}>
                <th key={0} className="GroupDetails-Team">
                  <Link name="teamDetails" params={{id: teamLeft.id}}>{teamLeft.title}</Link>
                </th>
                {_.map(teams, (teamTop, indexx) => {
                  if(teamLeft.id === teamTop.id) return <td className="GroupDetails-Result--SameTeam" key={indexx}></td>

                  const topRightCellGames = _.filter(games, game=>
                    game.team_a.id === teamLeft.id && game.team_b.id === teamTop.id
                  );
                  const bottomLeftCellGames = _.filter(games, game=>
                    game.team_b.id === teamLeft.id && game.team_a.id === teamTop.id
                  );
                  const topRightResults = _.reduce(topRightCellGames, (result, game) => {
                    _.each(game.results, gameResult=> {
                      if (gameResult.team_a_score >= gameResult.team_b_score) result[0]++;
                      if (gameResult.team_a_score <= gameResult.team_b_score) result[1]++;
                    });
                    return result;
                  }, [0, 0]);
                  const bottomLeftResults = _.reduce(bottomLeftCellGames, (result, game) => {
                    _.each(game.results, gameResult=> {
                      if (gameResult.team_b_score >= gameResult.team_a_score) result[0]++;
                      if (gameResult.team_b_score <= gameResult.team_a_score) result[1]++;
                    });
                    return result;
                  }, [0, 0]);
                  return (
                    <td className="GroupDetails-Result" key={indexx}>
                      {topRightCellGames[0] &&
                        <Link name="gameDetails" params={{id: topRightCellGames[0].id}}>
                          {topRightCellGames[0].status === 2 && 'В процессе' || (
                            topRightResults[0] > 0 || topRightResults[1] > 0 ?
                            topRightResults[0] + ':' + topRightResults[1] :
                            topRightCellGames[0].planned_time && dateTimeYear(topRightCellGames[0].planned_time) || ''
                          )}
                        </Link>
                      }
                      {bottomLeftCellGames[0] &&
                      <Link name="gameDetails" params={{id: bottomLeftCellGames[0].id}}>
                        {bottomLeftCellGames[0].status === 2 && 'В процессе' || (
                          bottomLeftResults[0] > 0 || bottomLeftResults[1] > 0 ?
                          bottomLeftResults[0] + ':' + bottomLeftResults[1] :
                          bottomLeftCellGames[0].planned_time && dateTimeYear(bottomLeftCellGames[0].planned_time) || ''
                        )}
                      </Link>
                      }
                    </td>
                  );
                })}
              </tr>
            )}
          </tbody>
        </table>
      </div>
    )
  });
};

const Group = component('Group', function(props){
  let groupMembers = props.group.map((groupMember, index) => (<GroupMember key={'groupMember'+index} groupMember={groupMember}/>));
  return (
    <div className="TournamentGroupStage-GroupsGroup">
      <h2 className="GroupDetails-CallWrapper">Группа&nbsp;{props.index+1}
        <div
          className="GroupDetails-Call"
          onClick={()=> showGroupDetails(props.data.cursor('popup'), props.games)}>
          Матчи <SlicedHamburger/>
        </div>
      </h2>
      <Table size="compact" zeroMargin={true}>
        <Tr>
          <Th>КОМАНДА</Th>
          <Th width="40px">ОЧКИ</Th>
        </Tr>
        {groupMembers.map((groupMember) => (groupMember))}
      </Table>
    </div>
  );
});

const checkTeam = (teams, team) => {
  let teamId = team.get('id');
  if(!(teamId in teams)){
    teams[teamId] = team.toJS();
    teams[teamId].score = 0;
  }
  return teams[teamId];
};

const collectGroupTeams = (group) => {
  let allTeams = {};
  group.get('games').forEach((game) => {
    let teams = [checkTeam(allTeams, game.get('team_a')), checkTeam(allTeams, game.get('team_b'))];
    if(game.get('results').size > 0) {
      let results = summGameResults(game.get('results').toJS());
      results[0] > results[1] ? teams[0].score += 3 : teams[1].score += 3;
    }
  });

  return _.sortBy(_.values(allTeams), 'score').reverse();
};

export default component('TournamentGroupStage', function({data, params, stage}){
  // to be refactored

  let roundId = parseInt(params.modificator);
  let rounds = stage.get('rounds');
  let roundsData = {};

  let tabs = [];
  rounds.map((round, index)=> {
    if(!roundId && index === 0){
      roundId = round.get('id');
    }
    tabs.push(<Tab key={'round'+round.get('id')} selected={round.get('id') === roundId}
                   header={<Link name="tournamentStageInner" params={{id: params.id, stageId: params.stageId, modificator: round.get('id')}} keepScroll={true}>Раунд {round.get('number')}</Link>}></Tab>);
    let groups = [];
    round.get('groups').forEach((group) => {
      groups.push({
        teams: collectGroupTeams(group),
        games: group.get('games').toJS()
      });
    });
    roundsData[round.get('id')] = {};
    roundsData[round.get('id')].groups = groups.map((group, index) => (<Group data={data} group={group.teams} games={group.games} key={'group'+index} index={index}/>));
    roundsData[round.get('id')].id = round.get('id');
    roundsData[round.get('id')].number = round.get('number');
  });

  let round = null;
  if(roundId){
    round = roundsData[roundId];
  }

  return (
    <div className="TournamentGroupStage">
      <h1>Этап №{stage.get('number')}: {stage.get('title')}</h1>

      <Tabs noDefaultSelected={true}>
        {tabs.map((tab)=>(tab))}
      </Tabs>

      <div className="TournamentGroupStage-Groups">
        {round && round.groups.map((group) => (group))}
      </div>
    </div>
  );
});


// WEBPACK FOOTER //
// ./src/components/pages/TournamentGroupStage.js